import { ProjectId, AssetId, getAsset } from 'owa-timestream-store';

export default function sortChildAssets(projectId: ProjectId, childAssetIds: AssetId[]) {
    if (!projectId || !childAssetIds) {
        return [];
    }

    return childAssetIds
        .filter((val, index, self) => self.indexOf(val) === index)
        .map(id => {
            const { type, order = 0 } = getAsset(projectId, id);
            return { id, type, order };
        })
        .sort((a, b) => a.order - b.order);
}
